import CustomAutoReply from "./pages/CustomAutoReply";
import Workflows from "./pages/Workflows";
import AIIntent from "./pages/AIIntent";
import AIAgent from "./pages/AIAgent";
import BasicAutomations from "./pages/BasicAutomations";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import ContactAttributes from './pages/ContactAttributes';
import CampaignReports from './pages/CampaignReports';
import Templates from './pages/Templates';
import Reports from './pages/Reports';
import AdminPanel from './pages/AdminPanel';
import Contacts from './pages/Contacts';
import MessageLogs from './pages/MessageLogs';
import Inbox from './pages/Inbox';
import Credit from './pages/Credit';
import LinkShortener from './pages/LinkShortener';
import Automation from './pages/Automation';
import ConnectWhatsApp from './pages/ConnectWhatsApp';
import AbandonCart from './pages/AbandonCart';
import Leads from './pages/Leads';
import Integrations from './pages/Integrations';
import NotificationSettings from './pages/NotificationSettings';
import Register from './pages/Register';
import WhatsAppProfile from './pages/WhatsAppProfile';
import Tags from './pages/Tags';
import WhatsAppForms from './pages/WhatsAppForms';
import Analytics from './pages/Analytics';
import Agents from './pages/Agents';
import AgentLogin from './pages/AgentLogin';
import AgentInbox from './pages/AgentInbox';
import MobileLogin from './pages/mobile/MobileLogin';
import MobileInbox from './pages/mobile/MobileInbox';
import ConnectShopify from './pages/ConnectShopify';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'DM Sans, sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 32, color: '#25D366', fontWeight: 800, marginBottom: 12 }}>VBOT</div>
        <div style={{ color: '#9ca3af', fontSize: 14 }}>Loading...</div>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/agent-login" element={<AgentLogin />} />
          <Route path="/agent-inbox" element={<AgentInbox />} />
          <Route path="/register" element={<Register />} />
          <Route path="/connect-shopify" element={<ConnectShopify />} />
          <Route path="/mobile-login" element={<MobileLogin />} />
          <Route path="/mobile-inbox" element={<MobileInbox />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="campaign-reports" element={<CampaignReports />} />
            <Route path="contact-attributes" element={<ContactAttributes />} />
            <Route path="templates" element={<Templates />} />
            <Route path="reports" element={<Reports />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="agents" element={<Agents />} />
            <Route path="admin" element={<AdminPanel />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="message-logs" element={<MessageLogs />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="credit" element={<Credit />} />
            <Route path="link-shortener" element={<LinkShortener />} />
            <Route path="automation" element={<Automation />}>
  <Route index element={<BasicAutomations />} />
  <Route path="custom-reply" element={<CustomAutoReply />} />
  <Route path="workflows" element={<Workflows />} />
  <Route path="ai-intent" element={<AIIntent />} />
  <Route path="ai-agent" element={<AIAgent />} />
</Route>
            <Route path="connect" element={<ConnectWhatsApp />} />
            <Route path="whatsapp-profile" element={<WhatsAppProfile />} />
            <Route path="tags" element={<Tags />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="notifications" element={<NotificationSettings />} />
            <Route path="whatsapp-forms" element={<WhatsAppForms />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
